import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import { ShieldCheckIcon } from '../components/Icons.js';

export function Connect() {
  const { isAuthenticated, isConnecting, error, connectWallet, clearError } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/wallet', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="connect-page">
      <div className="card connect-card">
        <ShieldCheckIcon className="connect-logo-icon" aria-hidden="true" />
        <h1>Connect Wallet</h1>
        <p className="connect-subtitle">
          Securely connect your wallet to access your CryptoGuardians Account Center.
        </p>

        {error && (
          <div className="error-message" style={{ marginBottom: '1rem' }}>
            {error}
            <button
              onClick={clearError}
              style={{
                background: 'none',
                border: 'none',
                color: 'inherit',
                float: 'right',
                cursor: 'pointer',
                fontWeight: 'bold',
              }}
              aria-label="Dismiss error"
            >
              &times;
            </button>
          </div>
        )}

        <button
          className="btn btn-primary btn-lg btn-primary-glow"
          onClick={connectWallet}
          disabled={isConnecting}
        >
          {isConnecting ? (
            <>
              <span className="spinner" /> Connecting...
            </>
          ) : (
            'Connect Wallet'
          )}
        </button>

        <p className="connect-wallet-support">
          Supports MetaMask, hardware wallets, and secure Web3 wallets.
        </p>

        <div className="connect-trust-list">
          <span>No password required</span>
          <span>No seed phrase required</span>
          <span>No transaction required</span>
        </div>

        <p className="connect-security-note">
          CryptoGuardians never has access to your funds.
          Authentication uses secure cryptographic signatures.
        </p>

        <Link to="/" className="connect-back-link">&larr; Back to Homepage</Link>
      </div>
    </div>
  );
}
